import React from 'react';
export default function RegexValidateOnlySpace() {
    return '.*[^ ].*';
}
